import { Injector } from "@angular/core";

export class ServiceLocatorService {
    static injector: Injector;
    constructor() { }
}
